// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bc-4";
export var collapsed = "_bc-1";
export var headerBar = "_bc-0";
export var leftHeaderContent = "_bc-3";
export var subjectContainer = "_bc-2";